import type { ApplicationContext } from './shared-types'
import type { SilverfinEvents } from '@app/types'

import { askUnreviewConfirmation } from '@app/shared/services/data-alteration-guard'

// The Sprockets bundle under app/assets/javascripts_deprecated cannot import a
// module, so window.eventHub is the only channel it can reach.
// TODO(pkatrimo): delete once no file emits confirmUnreviewTemplate, see #33817.
const answerLegacyRequest = async ({
  callback,
  rejectCallback,
  keepOpenAfterConfirmation,
}: SilverfinEvents['confirmUnreviewTemplate']): Promise<void> => {
  const { confirmed, skipUnprepare } = await askUnreviewConfirmation({
    keepOpenAfterConfirmation,
  })

  if (!confirmed) {
    rejectCallback?.()
    return
  }

  callback({ skipUnprepare })
}

// window.eventHub outlives a Turbolinks visit, so this runs once per bundle. A
// second subscription would answer each request twice.
export default (appContext: ApplicationContext): ApplicationContext => {
  window.eventHub.$on('confirmUnreviewTemplate', (payload) => {
    void answerLegacyRequest(payload)
  })

  return appContext
}
